import { IMAGE_LOADING, IMAGE_DECODING, IMAGE_FETCHPRIORITY } from "../../../constants/image";
import styled from 'styled-components';
// Our current version of the `styled-components` (">= 5") is filtering
// custom and experimental attributes passed down to HTMLElement — e.g., `fetchpriority`.

// TODO: This component should be remove once `styled-components` supports `fetchpriority`
// or if `fetchpriority` is deprecated.

export var ImageWithLazyAttributes = styled.img.withConfig({
  /* stylelint-disable-next-line */
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return defaultValidatorFn(prop) || ['fetchpriority'].includes(prop);
  }
}).attrs(function (_ref) {
  var loading = _ref.loading,
    decoding = _ref.decoding,
    fetchpriority = _ref.fetchpriority;
  return {
    loading: loading || IMAGE_LOADING.lazy,
    decoding: decoding || IMAGE_DECODING.async,
    fetchpriority: fetchpriority || IMAGE_FETCHPRIORITY.low
  };
}).withConfig({
  componentId: "sc-15jnh2j-0"
})([""]);